import React from 'react';
import { Row, Col, Modal, Button, Divider, Form, Input } from 'antd';
import useForm from '../hooks/useForm';
import { SelectWhatsappService } from 'components/select';

const ModalForm = ({ data = {}, visible, hideModal, fetchTable }) => {
    const [form] = Form.useForm(); // initialize form

    const {
        values,
        loading,
        handleSubmit,
    } = useForm(data, fetchTable, hideModal);

    return (
        <Modal
            maskClosable={false}
            keyboard={false}
            title="Form WhatsApp Service"
            open={visible}
            onCancel={hideModal}
            closable={false}
            footer={null}
        >
            <Form
                form={form}
                name="whatsappServiceForm"
                autoComplete="off"
                layout="vertical"
                onFinish={handleSubmit}
                loading={loading}
                initialValues={values}
            >
                <Row gutter={[16, 0]}>
                    <Col xs={24}>

                        <Form.Item
                            label="Service"
                            name="whatsapp_service_id"
                            rules={[{ required: true, message: 'Service harus diisi!' }]}
                        >
                            <SelectWhatsappService allowclear />
                        </Form.Item>

                    </Col>
                    <Col xs={24}>
                        <Form.Item
                            label="API Key"
                            name="api_key"
                            rules={[{ required: true, message: 'API Key harus diisi!' }]}
                        >
                            <Input placeholder="Ex: 6PORI7HXQFL02IAS" />
                        </Form.Item>
                    </Col>

                    <Col xs={24}>
                        <Form.Item
                            label="Nomor WhatsApp"
                            name="wa_number"
                            rules={[{ required: true, message: 'Nomor WhatsApp harus diisi!' }]}
                        >
                            <Input placeholder="Ex: 6285147777699" />
                        </Form.Item>
                    </Col>

                    <Col xs={24}>
                        <Form.Item
                            label="Key Number"
                            name="key_number"
                            rules={[{ required: true, message: 'Key Number harus diisi!' }]}
                        >
                            <Input placeholder="Ex: QXhWdUfgUgyVWgyT" />
                        </Form.Item>
                    </Col>

                    <Col xs={24}>
                        <Divider />
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                            <Button onClick={hideModal} disabled={loading}>Batal</Button>
                            <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                                Simpan
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default ModalForm;
